interface Props {
  totalClicks: number;
  totalConversions: number;
  totalEarnings: number;
  pendingEarnings: number;
}

export default function ReferralStatsBar({ totalClicks, totalConversions, totalEarnings, pendingEarnings }: Props) {
  const conversionRate = totalClicks > 0 ? ((totalConversions / totalClicks) * 100).toFixed(1) : "0.0";

  const stats = [
    { label: "Total Clicks", value: totalClicks.toLocaleString(), icon: "ri-cursor-line", color: "text-orange-500", bg: "bg-orange-50" },
    { label: "Conversions", value: totalConversions.toLocaleString(), icon: "ri-shopping-bag-line", color: "text-green-500", bg: "bg-green-50" },
    { label: "Conversion Rate", value: `${conversionRate}%`, icon: "ri-percent-line", color: "text-rose-500", bg: "bg-rose-50" },
    { label: "Total Earned", value: `$${totalEarnings.toFixed(2)}`, icon: "ri-money-dollar-circle-line", color: "text-orange-500", bg: "bg-orange-50" },
    { label: "Pending Payout", value: `$${pendingEarnings.toFixed(2)}`, icon: "ri-time-line", color: "text-amber-500", bg: "bg-amber-50" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
      {stats.map((s) => (
        <div key={s.label} className="bg-white rounded-xl border border-gray-100 p-4">
          <div className={`w-9 h-9 flex items-center justify-center ${s.bg} rounded-lg mb-3`}>
            <i className={`${s.icon} ${s.color} text-lg`} />
          </div>
          <p className="text-xl font-extrabold text-gray-900">{s.value}</p>
          <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
        </div>
      ))}
    </div>
  );
}
